import React from 'react';
import classNames from 'classnames';

/**
 * Provides a container query that renders a CSS grid with the following
 * column classes:
 *
 * grid-cols-2: min-width: 364px
 * grid-cols-3: min-width: 600px
 *
 * This allows for <MainContent> children to use the size of the <MainContent>
 * itself to determine what kind of grid layout to use vs using the `md:` or
 * `lg:` media query modifier classes.
 */
export default function MainContentGridContainerQuery({
  children,
  className,
  component: Component = 'div',
}: {
  children: React.ReactNode;
  className?: string;
  component?: React.ElementType;
}) {
  return (
    <Component
      className={classNames(
        'grid gap-3 @xs/MainContent:grid-cols-2 @sm/MainContent:grid-cols-3 supports-[not(container-type:inline-size)]:grid-cols-2 supports-[not(container-type:inline-size)]:sm:grid-cols-3 supports-[not(container-type:inline-size)]:md:grid-cols-2 supports-[not(container-type:inline-size)]:lg:grid-cols-2',
        className,
      )}
    >
      {children}
    </Component>
  );
}
